/**
 * Initials for an avatar fallback: first + last word's first letter, uppercased.
 * "Jan de Vries" → "JV", "Linda" → "L", "" → "?". Shared by the Smoelenboek,
 * Berichten, and Profile avatars so the fallback stays consistent.
 */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (!parts[0]) return '?';
  if (parts.length === 1) return (parts[0][0] ?? '?').toUpperCase();
  return ((parts[0][0] ?? '') + (parts[parts.length - 1]?.[0] ?? '')).toUpperCase();
}

const MS_PER_DAG = 86_400_000;
function dagStart(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** Dagscheiding in een gesprek: "Vandaag", "Gisteren", "12 augustus", "12 augustus 2025". */
export function dayLabel(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  const diff = Math.round((dagStart(now) - dagStart(d)) / MS_PER_DAG);
  if (diff === 0) return 'Vandaag';
  if (diff === 1) return 'Gisteren';
  const opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long' };
  if (d.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
  return d.toLocaleDateString('nl-NL', opts);
}

/** Tijdstempel in een lijst: "14:51" vandaag, "Gisteren", anders "12 aug". */
export function listTime(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  const diff = Math.round((dagStart(now) - dagStart(d)) / MS_PER_DAG);
  if (diff === 0) return d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
  if (diff === 1) return 'Gisteren';
  return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }).replace('.', '');
}
